var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFigmaLogo = function SvgIconFigmaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.851 2.664a4.2 4.2 0 0 1 2.962-1.227h6.374a4.187 4.187 0 0 1 2.716 7.375A4.187 4.187 0 0 1 13 15.571v2.804a4.188 4.188 0 1 1-6.903-3.187A4.18 4.18 0 0 1 4.625 12a4.19 4.19 0 0 1 1.472-3.187 4.19 4.19 0 0 1-1.472-3.188c0-1.11.441-2.176 1.226-2.961m2.962 11.524H11V9.811H8.813a2.188 2.188 0 0 0 0 4.376m0 2A2.187 2.187 0 1 0 11 18.375v-2.187zm6.374-8.375H13V3.438h2.188a2.187 2.187 0 1 1 0 4.374M8.814 3.438H11v4.374H8.813a2.188 2.188 0 0 1 0-4.374M13 12a2.188 2.188 0 1 1 4.375 0A2.188 2.188 0 0 1 13 12",
    clipRule: "evenodd"
  })));
};
export default SvgIconFigmaLogo;